import styled from 'styled-components';

export const SidebarMenuContainer = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;

  > * {
    flex-shrink: 0;
  }
`;

export const SidebarMenuNavIndicator = styled.div`
  position: absolute;
  transition: top 200ms;
  height: 36px;
  width: 4px;
  left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${({ theme }) => theme.primary};
`;
